import { render, staticRenderFns } from "./SlaBardCard.vue?vue&type=template&id=6f8949b7&scoped=true"
import script from "./SlaBardCard.vue?vue&type=script&lang=js"
export * from "./SlaBardCard.vue?vue&type=script&lang=js"
import style0 from "./SlaBardCard.vue?vue&type=style&index=0&id=6f8949b7&prod&scoped=true&lang=css"
import style1 from "./SlaBardCard.vue?vue&type=style&index=1&id=6f8949b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8949b7",
  null
  
)

export default component.exports